/** Legal pages on the landing site — the one source for these URLs in the app. */
export const TERMS_URL = "https://www.denker.ai/terms";
export const PRIVACY_URL = "https://www.denker.ai/privacy";
